module.exports = __webpack_public_path__ + "src/assets/img/smoke_four.d8f1a56e.svg";